import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant pour tracker les changements de route avec Google Tag Manager
 * Dans une SPA React, les changements de route ne déclenchent pas automatiquement
 * les événements de page view, il faut les envoyer manuellement au dataLayer
 */
function GTMTracker() {
  const location = useLocation();

  useEffect(() => {
    // Vérifier que window.dataLayer existe (GTM doit être chargé)
    if (typeof window !== 'undefined' && window.dataLayer) {
      // Pousser l'événement de page view au dataLayer
      window.dataLayer.push({
        event: 'page_view',
        page_path: location.pathname + location.search,
        page_title: document.title,
        page_location: window.location.href,
      });
      
      console.log('📊 GTM: Page view tracked', {
        path: location.pathname + location.search,
        title: document.title,
      });
    } else {
      console.warn('⚠️ GTM: dataLayer not found. Make sure Google Tag Manager is loaded.');
    }
  }, [location]);

  return null; // Ce composant ne rend rien
}

export default GTMTracker;







